import * as dashbord from '../services';

const parseLabelMin = (label) => {
  if (label === null) {
    return Number.MAX_SAFE_INTEGER;
  }
  const str = String(label);
  const nums = str.match(/\d+/g);
  if (!nums || nums.length === 0) {
    return Number.MAX_SAFE_INTEGER;
  }
  return parseInt(nums[0], 10);
};

const extractLabel = (item) => {
  if (!item || !Array.isArray(item.values)) {
    return undefined;
  }
  const found = item.values.find((v) => v && v.valueType === 'LABEL');
  return found ? found.value : undefined;
};

const parseBucketMin = (item) => parseLabelMin(extractLabel(item));

export default {
  namespace: 'dashbord',

  state: {
    chart1Data: {},
    chart2Data: {},
    chart3Data: {},
    chart4Data: {},
    chart5Data: {},
    chart6Data: {},
    chart7Data: [],
    chart8Data: {},
    chart9Data: {},
    chart10Data: {},
    chart11Data: {},
    chart12Data: {},
    chart13Data: {},
    dictData: [],
  },

  effects: {
    //基础信息
    *getStatistics({ payload: { values } }, { call, put }) {
      const response = yield call(dashbord.getStatistics, values);
      // if (!response.errCode) {
      //   if (callback && typeof callback === 'function') {
      //     callback(response.data);
      //   }
      // }
      yield put({
        type: 'save',
        payload: {
          chart1Data: response?.data || {},
        },
      });
    },
    //订单金额趋
    *getOrder({ payload: { values } }, { call, put }) {
      const response = yield call(dashbord.getOrder, values);
      yield put({
        type: 'save',
        payload: {
          chart2Data: response?.data || {},
        },
      });
    },
    // 积分增长、消耗趋势
    *getPoint({ payload: { values } }, { call, put }) {
      const response = yield call(dashbord.getPoint, values);
      yield put({
        type: 'save',
        payload: {
          chart3Data: response?.data || {},
        },
      });
    },
    // 年龄分布
    *getAge({ payload: { values } }, { call, put }) {
      const response = yield call(dashbord.getAge, values);
      yield put({
        type: 'save',
        payload: {
          // chart4Data: response?.data || {},
          chart4Data: response ? response : {},
        },
      });
    },
    // 来源分布
    *getSource({ payload: { values } }, { call, put }) {
      const response = yield call(dashbord.getSource, values);
      yield put({
        type: 'save',
        payload: {
          chart5Data: response?.data || {},
        },
      });
    },
    // 活跃用户分布
    *getActiveUser({ payload: { values } }, { call, put }) {
      const response = yield call(dashbord.getActiveUser, values);
      yield put({
        type: 'save',
        payload: {
          chart6Data: response?.data || {},
        },
      });
    },
    // 等级分布
    *getGrade({ payload: { values } }, { call, put }) {
      const response = yield call(dashbord.getGrade, values);
      // console.log(response, 'response');
      if (response?.code === 0) {
        yield put({
          type: 'save',
          payload: {
            chart7Data: response?.data || [],
          },
        });
      }
    },
    // 会员变化趋势
    *getCount({ payload: { values } }, { call, put }) {
      const response = yield call(dashbord.getCount, values);
      if (response?.code === 0) {
        yield put({
          type: 'save',
          payload: {
            chart8Data: response?.data || {},
          },
        });
      }
    },
    // 获取字典数据
    *getDict({ payload: {}, callback }, { call, put }) {
      const response = yield call(dashbord.getDict);
      if (callback && typeof callback === 'function') {
        return callback(response.data);
      }
      yield put({
        type: 'save',
        payload: {
          dictData: response ? response.data : [],
        },
      });
    },
    // 查询积分持有分布报表
    *getPointDistribution({ payload: { values } }, { call, put }) {
      const response = yield call(dashbord.getPointDistribution, values);
      // console.log(response, 'response');
      if (response?.code === 0) {
        const sorted = (response?.data || []).slice().sort((a, b) => {
          const aMin = parseBucketMin(a);
          const bMin = parseBucketMin(b);
          return aMin - bMin;
        });
        yield put({
          type: 'save',
          payload: {
            chart9Data: sorted,
          },
        });
      }
    },
    // 查询性别分布报表
    *getGenderDistribution({ payload: { values } }, { call, put }) {
      const response = yield call(dashbord.getGenderDistribution, values);
      // console.log(response, 'response');
      yield put({
        type: 'save',
        payload: {
          chart10Data: response ? response : {},
        },
      });
    },
    // 查询小程序整体访问报表
    *getMiniAppAccess({ payload: { values } }, { call, put }) {
      const response = yield call(dashbord.getMiniAppAccess, values);
      // console.log(response, 'response');
      if (response?.code === 0) {
        yield put({
          type: 'save',
          payload: {
            chart11Data: response?.data || [],
          },
        });
      }
    },
    // 查询消费能力分布报表
    *getConsumptionDistribution({ payload: { values } }, { call, put }) {
      const response = yield call(dashbord.getConsumptionDistribution, values);
      // console.log(response, 'response');
      if (response?.code === 0) {
        yield put({
          type: 'save',
          payload: {
            chart12Data: response?.data || [],
          },
        });
      }
    },
    // 查询地域分布报表
    *getRegionDistribution({ payload: { values } }, { call, put }) {
      const response = yield call(dashbord.getRegionDistribution, values);
      // console.log(response, 'response');
      if (response?.code === 0) {
        yield put({
          type: 'save',
          payload: {
            chart13Data: response?.data || [],
          },
        });
      }
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history }) {
      return history.listen(() => {});
    },
  },
};
